module.exports = __webpack_public_path__ + "static/media/1009838.3893c604.jpg";